var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import { EPurOrderStatus } from "../../../enum/EStatus";
import { toDetail } from "../../../helper/util";
import { EBillType } from "../../../enum/EBillType";
import PageService from '../../../api/PageService';
import OperationReportService from '../../../api/OperationReportService';
import OrderService from '../../../api/OrderService';
import DeliveryService from '../../../api/DeliverService';
import KeyConfig from '../../../components/common/KeyConfig.vue';
import BillSubTable from "./BillSubTable.vue";
import DeliveryDialog from './DeliveryDialog.vue';
var TableList = (function (_super) {
    __extends(TableList, _super);
    function TableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.colmuns = [];
        _this.multiColmuns = [];
        _this.dataSource = [];
        _this.total = 0;
        _this.tableKey = 1;
        _this.purOrderStatus = EPurOrderStatus;
        _this.eBillType = EBillType;
        _this.dialogVisible = false;
        _this.dialogTableData = Array;
        return _this;
    }
    TableList.prototype.watchCols = function (newCols, oldCols) {
        if (newCols) {
            this.colmuns = newCols;
            this.renderTable();
        }
    };
    TableList.prototype.watchtemplateType = function (newVal, oldVal) {
        this.getPageConfig(this.fetch);
        this.layoutTable();
    };
    TableList.prototype.created = function () {
        this.service = PageService.getInstance();
        this.deliveryService = DeliveryService.getInstance();
        this.orderservice = OrderService.getInstance();
        this.serviceList = OperationReportService.getInstance();
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.getPageConfig(this.fetch);
        this.layoutTable();
        console.log('openedCodeData', this.openedCodeData);
    };
    TableList.prototype.renderTable = function () {
        this.tableKey = Math.random();
    };
    TableList.prototype.initColmun = function (colmuns) {
        var _this = this;
        var freezeIndex = colmuns.findIndex(function (item) { return item.is_freeze; });
        colmuns.map(function (item, index) {
            if (_this.filterColumns.includes(item.key)) {
                item.rowHidden = true;
                item.is_hidden = 1;
            }
            if (item.type && colmuns[index + 1] && item.type === colmuns[index + 1].type) {
                item.freezeDisabled = true;
            }
            if (index <= freezeIndex) {
                item.fixed = true;
            }
            else {
                item.fixed = false;
            }
            return item;
        });
        if (this.isMultiHeader) {
            var multiColmuns = _.cloneDeep(colmuns);
            this.multiColmuns = this.multiColmunsSet(multiColmuns);
        }
        colmuns.forEach(function (column) {
            if (column.key === 'order_code') {
                column.width = 165;
            }
            if (column.key === 'delivery_order_codes') {
                column.width = 140;
            }
            if (column.key === 'warehouse_receipt_codes') {
                column.width = 140;
            }
            if (column.key === 'order_arriveddate') {
                column.width = 130;
            }
        });
        return colmuns;
    };
    TableList.prototype.configUpdate = function (configData) {
        this.colmuns = this.initColmun(configData);
        this.renderTable();
    };
    TableList.prototype.showKeyConfig = function () {
        this.$refs.KeyConfig.show(this.colmuns, this.templateType);
    };
    TableList.prototype.selectionChange = function (val) {
        this.$emit('selectionChange', val);
    };
    TableList.prototype.getPageConfig = function (callBack) {
        var _this = this;
        if (!this.isShowKeyConfig)
            return;
        this.service.getPage({
            template_type: this.templateType,
        })
            .then(function (res) {
            var DATA = res.data.data;
            _this.colmuns = Array.isArray(DATA.template_config) ? _this.initColmun(DATA.template_config) : [];
        })
            .catch(function (err) {
            _this.loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    TableList.prototype.layoutTable = function () {
        var _this = this;
        this.$nextTick(function () {
            var table = _this.$refs.Table;
            table.resizeListener();
            _this.$nextTick(function () {
                var fixedLeft = table.$el.querySelector('.el-table__fixed');
                var fixedRight = table.$el.querySelector('.el-table__fixed-right');
                if (fixedLeft) {
                    fixedLeft.style.height = (table.layout.tableHeight - table.layout.gutterWidth) + 'px';
                }
                if (fixedRight) {
                    fixedRight.style.height = (table.layout.tableHeight - table.layout.gutterWidth) + 'px';
                }
            });
        });
    };
    TableList.prototype.fetch = function (pager, updatePager, renderTable) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        if (renderTable === void 0) { renderTable = true; }
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : pager;
        var params = {
            page: currentPager.page || 1,
            start: currentPager.start || 0,
            limit: currentPager.limit || 20,
            sort_field: this.order ? this.order[0] : null,
            sort_type: this.order ? this.order[1] : null
        };
        this.fetchAction(Object.assign({}, this.filter, params))
            .then(function (res) {
            _this.loadingInstance.close();
            var DATA = Array.isArray(res.data.data) ? res.data.data : [];
            DATA.map(function (item) {
                item.listGoods = [];
            });
            _this.dataSource = DATA;
            _this.layoutTable();
            _this.$emit('fetchCallBack', res.data);
            _this.total = res.data.total;
            renderTable && _this.renderTable();
        })
            .catch(function (err) {
            _this.loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    TableList.prototype.pageChange = function (pager) {
        this.fetch(pager, true);
    };
    TableList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (prop) {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        else {
            this.order = null;
        }
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.fetch({ page: 1, start: 0, limit: 20 }, false, false);
    };
    TableList.prototype.lookDetail = function (row) {
        this.$emit('lookDetail', row);
    };
    TableList.prototype.discard = function (status, id) {
        var _this = this;
        var msg = '';
        var params = {};
        if (status == 1) {
            msg = '确认后会废弃订货单且不可恢复，确定废弃吗？';
            params = {
                ids: id,
                type: 2
            };
        }
        else if (status == 3) {
            msg = '确认后会废弃订货单且不可恢复，确定废弃吗？';
            params = {
                ids: id,
                type: 3
            };
        }
        else {
            msg = '确定要废弃选中的订单吗？';
            params = {
                ids: id
            };
        }
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            _this.cancel(params);
        }).catch(function () { });
    };
    TableList.prototype.cancel = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.orderservice.cancel(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 81) {
                _this.$confirm(res.data.msg, "提示", {
                    cancelButtonText: "否",
                    confirmButtonText: "是",
                    dangerouslyUseHTMLString: true
                }).then(function (res) {
                    params.confirm = 1;
                    _this.cancel(params);
                });
            }
            else {
                _this.$message.success(res.data.msg || "废弃成功");
                _this.$emit('discard', params.ids);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    TableList.prototype.reject = function (id) {
        var _this = this;
        var msg = '确认后会驳回订货单，确定驳回吗？';
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            _this.doReject({ order_id: id });
        }).catch(function () { });
    };
    TableList.prototype.doReject = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.orderservice.reject(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || "驳回成功");
            _this.$emit('discard', params.order_id);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    TableList.prototype.deliver = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, length, item, list, business_id, _b, total, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [1, _.cloneDeep(row), [row]], length = _a[0], item = _a[1], list = _a[2];
                        business_id = item.business_id || 0;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        return [4, this.deliveryService.getDeliveryOrderList({ order_id: row.order_id })];
                    case 2:
                        _b = (_c.sent()).data, total = _b.total, data = _b.data;
                        list = (data || []).map(function (item) {
                            item.order_id = row.order_id;
                            return item;
                        });
                        length = total;
                        if (total === 0)
                            delete item.delivery_order_id;
                        else if (total === 1)
                            item = list[0] || item;
                        return [3, 4];
                    case 3:
                        if (length > 1) {
                            this.$refs.deliveryDialog.show('选择送货单', list);
                        }
                        else {
                            item.business_id = business_id;
                            this.toShip(item);
                        }
                        return [7];
                    case 4: return [2];
                }
            });
        });
    };
    TableList.prototype.toShip = function (row) {
        this.$emit("toShip", row);
    };
    TableList.prototype.confirm = function (row) {
        this.$emit("confirm", row);
    };
    TableList.prototype.modify = function (row) {
        this.$emit('modify', row);
    };
    TableList.prototype.copyData = function (row) {
        this.$emit('copyData', row);
    };
    TableList.prototype.toPage = function (type, id) {
        toDetail(type, id);
    };
    TableList.prototype.showShippedCodeDialog = function (data, toPageType) {
        this.dialogVisible = true;
        this.dialogTableData = data;
        this.dialogTableData.forEach(function (item, index) {
            item["index"] = index + 1;
            item["toPageType"] = toPageType;
            item["label"] = toPageType == 2 ? "入库单号" : "送货单号";
            item["datail"] = toPageType == 2 ? item.warehouse_receipt_code : item.delivery_order_code;
        });
    };
    TableList.prototype.columnClick = function (row) {
        if (row.toPageType) {
            this.dialogVisible = false;
            toDetail(row.toPageType, row.toPageType == 2 ? row.warehouse_receipt_id : row.delivery_order_id);
        }
    };
    TableList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.dataSource.indexOf(row);
        this.orderservice.getListGoods(params).then(function (res) {
            _.forEach(res.data.data, function (item) {
                item.amount = item.order_detail_amount;
            });
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            _this.dataSource[index].listGoods = listGoods;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    __decorate([
        Prop({
            default: document.documentElement.clientHeight - 240,
        })
    ], TableList.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "cols", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], TableList.prototype, "fetchAction", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "dataActions", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "sortColumns", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "filterColumns", void 0);
    __decorate([
        Prop({
            default: {},
        })
    ], TableList.prototype, "filter", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "showSummary", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "setSummary", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "isShowKeyConfig", void 0);
    __decorate([
        Prop({
            default: 1,
        })
    ], TableList.prototype, "templateType", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "renderTitleKeys", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "renderContentKeys", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "isMultiHeader", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "multiColmunsSet", void 0);
    __decorate([
        Prop({
            default: false
        })
    ], TableList.prototype, "checkbox", void 0);
    __decorate([
        Prop({
            default: '0',
            type: String
        })
    ], TableList.prototype, "status", void 0);
    __decorate([
        Watch('cols', { immediate: true })
    ], TableList.prototype, "watchCols", null);
    __decorate([
        Watch('templateType')
    ], TableList.prototype, "watchtemplateType", null);
    TableList = __decorate([
        Component({
            components: {
                KeyConfig: KeyConfig,
                BillSubTable: BillSubTable,
                DeliveryDialog: DeliveryDialog
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus'
            }))
        })
    ], TableList);
    return TableList;
}(Vue));
export default TableList;
